import React from 'react';
import { Tag } from 'lucide-react';

interface CategoryFilterProps {
  selectedCategory: string | null;
  onSelect: (category: string | null) => void;
  categories: string[];
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  selectedCategory,
  onSelect,
  categories
}) => {
  return (
    <div className="flex items-center space-x-2 overflow-x-auto pb-2">
      <button
        onClick={() => onSelect(null)}
        className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${
          !selectedCategory
            ? 'bg-purple-500 text-white'
            : 'bg-white/10 text-purple-200 hover:bg-white/20'
        }`}
      >
        <Tag className="w-4 h-4 inline mr-2" />
        Todos
      </button>

      {categories.map(category => (
        <button
          key={category}
          onClick={() => onSelect(category)}
          className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${
            selectedCategory === category
              ? 'bg-purple-500 text-white'
              : 'bg-white/10 text-purple-200 hover:bg-white/20'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};